<div class="form-group monthday-input-list">
  <div class="monthday-input-group" *ngFor="let input of inputs; index as i">
    <input
      type="text"
      [ngClass]="{'form-control': true, 'invalid': !input.valid }"
      [value]="input.value"
      (change)="onChange(i, $event)"
      (keyup)="onChange(i, $event)"
    />
    <button
      [ngClass]="{'btn': true, 'btn-default': true, 'btn-xs': true, 'disabled': inputs.length === 1}"
      type="button"
      (click)="onRemoveClick(i)"
    ><i class="fa fa-remove fa-lg"></i></button>
  </div>
</div>
<div class="form-group actions">
  <a role="button" type="button" class="add-day" (click)="onAddClick()">Add another day</a>
</div>
